
export const SHOW_SEARCH = 'SHOW_SEARCH';
export const FETCH_HISTORY = 'FETCH_HISTORY';
export const CREATE_TRIAL = 'CREATE_TRIAL';
export const CREATE_SOA = 'CREATE_SOA';
export const UPDATE_SOA_ACTIVITIES = 'UPDATE_SOA_ACTIVITIES';
export const UPDATE_IE_ACTIVITIES = 'UPDATE_IE_ACTIVITIES';
export const UPDATE_ENDPOINTS = 'UPDATE_ENDPOINTS';
export const SET_PRESETS = 'SET_PRESETS';
export const TRIAL_ALIAS_STYLE = {
  width: 800,
  fontSize: 28,
  color: "#333",
};
